
/* global store */
/* global PLACEMENT_ID */
/* global IS_PREVIEW_PAGE */
/* global ENVIRONMENT */
import { fireTracking } from 'Tracking/index';
import { getClosest } from 'Tracking/utils';

import {
  CAROUSEL_SLIDE_VIEW,
} from 'Tracking/constants/events';

import {
  AD_EVENT_DATA,
  AD_COMPONENT_TYPE,
  AD_COMPONENT_ID,
  AD_COMPONENT_NAME,
  AD_STATE,
} from 'Tracking/constants/trackingNames';

import {
  CAROUSEL,
} from 'Tracking/constants/componentTypes';


export const getCarouselComponentInfo = (elem) => {
  const componentId = elem ? elem.getAttribute('data-id') || null : null;
  const componentName = elem ? elem.getAttribute('data-name') || null : null;
  const componentContainer = elem ? getClosest(elem, 'div[data-artboard]') || null : null;
  const componentArtboard = componentContainer ? componentContainer.getAttribute('data-artboard') || null : null;
  return {
    [AD_COMPONENT_ID]: componentId,
    [AD_COMPONENT_NAME]: componentName,
    [AD_STATE]: componentArtboard,
  };
};

export const fireCarouselSlideView = (elem, slideNo) => {
  const type = { [AD_COMPONENT_TYPE]: CAROUSEL };
  fireTracking(CAROUSEL_SLIDE_VIEW, { ...type, [AD_EVENT_DATA]: slideNo, ...getCarouselComponentInfo(elem) });
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/actions/smartgroup.js